import { render, staticRenderFns } from "./booksRead.vue?vue&type=template&id=7f447142&scoped=true&"
import script from "./booksRead.vue?vue&type=script&lang=js&"
export * from "./booksRead.vue?vue&type=script&lang=js&"
import style0 from "./booksRead.vue?vue&type=style&index=0&id=7f447142&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f447142",
  null
  
)

export default component.exports